import{options as n,Fragment as o,Component as e}from"preact";"undefined"!=typeof window&&window.__PREACT_DEVTOOLS__&&window.__PREACT_DEVTOOLS__.attachPreact("10.5.4",n,{Fragment:o,Component:e});
//# sourceMappingURL=devtools.module.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/preact/devtools/dist/devtools.module.js
// module id = null
// module chunks = 